import React, { createContext, useContext, useState } from 'react';

const AdminContext = createContext();

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdmin must be used within an AdminProvider');
  }
  return context;
};

export const AdminProvider = ({ children }) => {
  const [isAdminMode, setIsAdminMode] = useState(false);
  const [adminManagedTournamentId, setAdminManagedTournamentId] = useState(null);

  const enterAdminMode = (tournamentId = null) => {
    setIsAdminMode(true);
    setAdminManagedTournamentId(tournamentId);
  };

  const exitAdminMode = () => {
    setIsAdminMode(false);
    setAdminManagedTournamentId(null);
  };

  return (
    <AdminContext.Provider
      value={{
        isAdminMode,
        adminManagedTournamentId,
        enterAdminMode,
        exitAdminMode
      }}
    >
      {children}
    </AdminContext.Provider>
  );
};
